import React, { useState } from 'react';
import styles from './index.module.less';
import Image from 'next/image';

const Index: React.FC<any> = ({ data }) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Image
          src={data.contentInfo.hero.imgPath}
          alt="dmca-takedown"
          width={1440}
          priority
          fetchPriority="high"
          height={340}
        />
        <div className={styles.main}>
          <h1>{data.contentInfo.hero.title}</h1>
          <div>{data.contentInfo.hero.desc}</div>
          <div className={styles.rights}>
            <div>
              <span>✓</span>
              <span>
                <span></span>
                <span>{data.contentInfo.hero.tags[0]}</span>
              </span>
            </div>
            <div>
              <span>✓</span>
              <span>
                <span></span>
                <span>{data.contentInfo.hero.tags[1]}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
